import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Cta from '../components/Cta.js';
import FeedbackModal from '../components/FeedbackModal';

function Layout({ children }) {
  const [isFeedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-[#0A0F1F] text-white">
      <Navbar />
      <main className="flex-grow">{children}</main>
      <Cta />
      <Footer />

      {/* Feedback Button */}
      <button
        onClick={() => setFeedbackOpen(true)}
        className="fixed top-1/2 transform -translate-y-1/2 bg-yellow-400 text-black text-xl py-2 px-3 rounded-md shadow-lg z-40 hover:bg-yellow-300"
        style={{
          transform: 'translateY(-50%) rotate(-90deg)',
          transformOrigin: 'center right',
          right: '10px', // Add margin to avoid overlap with the scrollbar
        }}
      >
        Feedback
      </button>

      {/* Feedback Modal */}
      <FeedbackModal
        isOpen={isFeedbackOpen}
        onClose={() => setFeedbackOpen(false)}
      />
    </div>
  );
}

export default Layout;
